import './services.product-set';
import './services.product';
import './services.tracker';
import './services.wishlist';
import './service.back-in-stock';
app.directive('slListPageWishlistButton', [
  '$rootScope',
  '$cookies',
  'mainConfig',
  'slFeatureService',
  'backInStockService',
  'wishlistService',
  'trackerService',
  'productService',
  'productSetService',
  function (
    $rootScope,
    $cookies,
    mainConfig,
    slFeatureService,
    backInStockService,
    wishlistService,
    trackerService,
    productService,
    productSetService,
  ) {
    return {
      templateUrl: require('../../../../../public/themes/shared/product/templates.sl_list_page_wishlist_button.html'),
      restrict: 'E',
      scope: {
        product: '=',
        hasVariations: '=',
        wishlistItems: '=',
        loginPath: '@',
      },
      link: function (scope, element) {
        scope.merchantId = mainConfig.merchantId;
        scope.userId = mainConfig.currentUser
          ? mainConfig.currentUser._id
          : null;
        scope.productId = scope.product._id;
        scope.shouldShowButton =
          slFeatureService.hasFeature('plp_wishlist') &&
          mainConfig.themeSettings.plp_wishlist;
        scope.isHoverButton = element.hasClass('hover-button');

        function isAllowMobileHoverButton() {
          var currentTheme = mainConfig.merchantData.current_theme_key;
          var enableTheme = ['philia', 'kingsman_v2', 'doris_bien'];
          return enableTheme.includes(currentTheme);
        }

        // Newly added function to determine if the product is present in the wishlist based on certain conditions.
        function isProductInWishlist(wishlistItems) {
          const PLP_VARIATION_DISPLAY_TYPE = {
            VARIATION_EXPANSION: 'variation_expansion',
          };

          const plpVariationDisplay =
            mainConfig.themeSettings.plp_variation_display;
          const variantId = element.attr('data-variant-id');

          if (!wishlistItems) {
            wishlistItems = scope.wishlistItems.filter(
              (item) => item.product._id === scope.productId,
            );
          }

          if (
            slFeatureService.hasFeature('expand_sku_on_plp') &&
            plpVariationDisplay?.type ===
              PLP_VARIATION_DISPLAY_TYPE.VARIATION_EXPANSION &&
            scope.product.variations?.length > 0 &&
            variantId
          ) {
            const wishlistVariantKeys = wishlistItems.map(
              (item) => item.variation_key,
            );
            return scope.product.variations.some(({ key }) =>
              wishlistVariantKeys.includes(key),
            );
          }

          return wishlistItems.length > 0;
        }

        if (scope.userId && scope.wishlistItems) {
          scope.isActive = isProductInWishlist();
        }

        scope.getWishlist = function () {
          if (
            $('sl-list-page-wishlist-button.hover-button').length === 0 ||
            (scope.isHoverButton &&
              window.matchMedia('(min-width: 992px)').matches) ||
            ((!scope.isHoverButton || isAllowMobileHoverButton()) &&
              window.matchMedia('(max-width: 991px)').matches) ||
            (mainConfig.merchantData.current_theme_key === 'swanky' &&
              window.matchMedia('(min-width: 992px)').matches)
          ) {
            wishlistService
              .getList({
                product_id: scope.productId,
                merchant_id: scope.merchantId,
                user_id: scope.userId,
              })
              .then(function (res) {
                scope.isActive = isProductInWishlist(res.data.items);
                $rootScope.$emit('plpWishlistItemUpdate', {
                  productId: scope.productId,
                  isActive: scope.isActive,
                  variantId: element.attr('data-variant-id'),
                  wishlistItems: res.data.items,
                });
              })
              .finally(function () {
                scope.isUpdating = false;
              });
          }
        };

        scope.sendTrackEvent = function (action) {
          if (action === 'addItem') {
            trackerService.addToWishlist(scope.product, 0, null);
          } else {
            trackerService.removeFromWishlist(scope.product);
          }
        };

        scope.toggleWishlistItem = function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (
            scope.hasVariations ||
            productSetService.isProductSetEnabled(scope.product)
          ) {
            return scope.openQuickCartModal(scope.productId);
          }

          if (productSetService.isProductSetRevampEnabled(scope.product)) {
            window.location = `/products/${scope.product._id}`;
            return;
          }

          if (!$rootScope.isUserLoggedIn) {
            angular.element(document).on('click.wishlistTooltip', function () {
              if (element.find('.Tooltip-wishlistTooltip').length) {
                angular
                  .element('.Tooltip-wishlistTooltip.is-tooltip-show')
                  .fadeOut()
                  .removeClass('is-tooltip-show');
              } else {
                angular.element(document).off('click.wishlistTooltip');
              }
            });

            element.find('.Tooltip-wishlistTooltip').fadeIn(300, function () {
              element
                .find('.Tooltip-wishlistTooltip')
                .addClass('is-tooltip-show');
            });
          } else {
            if (scope.isUpdating) return;

            scope.isUpdating = true;
            var wishlistItemData = {
              product_id: scope.productId,
              variation_key: '',
            };
            var toggleAction = function () {
              var apiAction = scope.isActive ? 'removeItem' : 'addItem';
              wishlistService[apiAction](wishlistItemData).finally(function () {
                scope.getWishlist();
                scope.sendTrackEvent(apiAction);
              });
            };

            if (!scope.isActive && backInStockService.isBackInStockAvailable) {
              productService.getById(scope.productId).then(function (response) {
                var product = response.data.data;
                if (backInStockService.shouldShowBtn(product)) {
                  wishlistItemData.is_subscribed_notify = true;
                }
                toggleAction();
              });
            } else {
              toggleAction();
            }
          }
        };

        scope.openQuickCartModal = function (productId) {
          if ($('.QuickCart-modal').length) return;

          var productItemElement = angular
            .element('product-item[product-id="' + productId + '"]')
            .has(element);
          var addToCartBtn = productItemElement.find(
            '.btn-add-to-cart:not(.quick-cart-item)',
          );
          var addToPromotionCartBtn = productItemElement.find(
            '.btn-add-to-promotion-cart',
          );

          if (addToCartBtn.length) {
            addToCartBtn.click();
          } else if (addToPromotionCartBtn.length) {
            addToPromotionCartBtn.click();
          } else {
            var productItemScope = productItemElement.scope();
            if (!productItemScope.modalOpened) {
              productItemScope.modalOpened = true;
              var variantId = element.attr('data-variant-id');
              productItemScope.quickAdd(variantId);
            }
          }
        };

        scope.toLoginPage = function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (scope.product.type !== 'product_set') {
            $cookies.put(
              'cookieWishlistItem',
              JSON.stringify({
                product_id: scope.productId,
                variation_key: '',
              }),
            );
          }
          window.location.href = scope.loginPath;
        };

        if (scope.isHoverButton) {
          scope.$watch('isActive', function () {
            scope.isActive
              ? element.addClass('is-active')
              : element.removeClass('is-active');
          });
        }

        $rootScope.$on('modal.close', function (event, data) {
          if (
            $rootScope.isUserLoggedIn &&
            data.productId === scope.productId &&
            (!data.variantId ||
              data.variantId === element.attr('data-variant-id'))
          ) {
            scope.getWishlist();
          }
        });

        $rootScope.$on('plpWishlistItemUpdate', function (event, data) {
          if (data.productId !== scope.productId) return;
          if (
            !data.variantId ||
            data.variantId === element.attr('data-variant-id')
          ) {
            scope.isActive = data.isActive;
            return;
          }
          scope.isActive = isProductInWishlist(data.wishlistItems);
        });

        $rootScope.$watch('cookieWishlistItem', function (newVal) {
          if (newVal && newVal.product_id === scope.productId) {
            if (newVal.variation_key) {
              scope.openQuickCartModal(newVal.product_id);
            }
            scope.getWishlist();
          }
        });
      },
    };
  },
]);
